import { render } from "./DiscountCodeBox.vue?vue&type=template&id=4f439bb0&scoped=true"
import script from "./DiscountCodeBox.vue?vue&type=script&lang=js"
export * from "./DiscountCodeBox.vue?vue&type=script&lang=js"

import "./DiscountCodeBox.vue?vue&type=style&index=0&id=4f439bb0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f439bb0"]])

export default __exports__